import styled from "styled-components";
import { Button, DatePicker, Flex, Typography } from "antd";
import { COLORS } from "../../../utils/colors";

const { Title, Text } = Typography;
const { RangePicker } = DatePicker;

export const WelcomeRow = styled(Flex)`
  && {
    margin-bottom: 20px;
  }
`;

// Zero flex-basis so the text never reserves width when the row decides where
// to break. Without this the controls drop onto their own row as soon as the
// page gains a scrollbar.
export const WelcomeBlock = styled(Flex)`
  && {
    flex: 1 1 0;
    min-width: 0;
  }

  @media (max-width: 991px) {
    && {
      flex: 1 1 100%;
    }
  }
`;

export const WelcomeTitle = styled(Title)`
  && {
    font-family: "Roboto", sans-serif;
    font-size: 28px !important;
    font-weight: 700 !important;
    color: ${COLORS.textBody} !important;
    margin: 0 !important;
    line-height: 36px !important;
  }

  @media (max-width: 575px) {
    && {
      font-size: 22px !important;
      line-height: 28px !important;
    }
  }
`;

export const WelcomeSubtitle = styled(Text)`
  && {
    font-family: "Roboto", sans-serif;
    font-size: 12px;
    color: ${COLORS.textMuted};
  }
`;

export const WelcomeControls = styled(Flex)`
  && {
    flex: 0 1 auto;
  }

  @media (max-width: 991px) {
    && {
      width: 100%;
      flex: 1 1 100%;
      flex-wrap: wrap;
    }
  }
`;

export const DateRangePill = styled(RangePicker)`
  &&.ant-picker {
    height: 38px;
    border-radius: 10px !important;
    padding: 0 18px;
    border: 1px solid ${COLORS.border} !important;
    background: ${COLORS.surface};
    font-family: "Roboto", sans-serif;
    font-size: 13px;
    color: ${COLORS.textBody};
    box-shadow: none !important;
    cursor: pointer;
    min-width: 260px;
    overflow: hidden;
  }

  &&.ant-picker .ant-picker-input {
    border-radius: inherit;
  }

  &&.ant-picker .ant-picker-input > input {
    font-family: "Roboto", sans-serif;
    font-size: 13px;
    color: ${COLORS.textBody};
    cursor: pointer;
  }

  &&.ant-picker .ant-picker-input > input::placeholder {
    color: ${COLORS.textMuted};
  }

  &&.ant-picker .ant-picker-prefix {
    color: ${COLORS.textBody};
    margin-inline-end: 10px;
    font-size: 14px;
  }

  &&.ant-picker .ant-picker-range-separator {
    color: ${COLORS.textMuted};
    padding: 0 6px;
  }

  &&.ant-picker .ant-picker-suffix {
    color: ${COLORS.textMuted};
    margin-inline-start: 10px;
    font-size: 14px;
  }

  &&.ant-picker .ant-picker-clear {
    background: ${COLORS.surface};
  }

  &&.ant-picker:hover,
  &&.ant-picker-focused {
    border-color: ${COLORS.border} !important;
    box-shadow: none !important;
    border-radius: 10px !important;
  }

  &&.ant-picker .ant-picker-active-bar {
    display: none;
  }

  @media (max-width: 991px) {
    &&.ant-picker {
      min-width: 0;
      flex: 1 1 60%;
      order: 3;
    }
  }
` as unknown as typeof RangePicker;

export const DatePopupWrap = styled.div`
  font-family: "Roboto", sans-serif;

  .ant-picker-panel-container {
    border-radius: 12px;
    overflow: hidden;
  }

  .ant-picker-cell-in-view.ant-picker-cell-selected .ant-picker-cell-inner,
  .ant-picker-cell-in-view.ant-picker-cell-range-start .ant-picker-cell-inner,
  .ant-picker-cell-in-view.ant-picker-cell-range-end .ant-picker-cell-inner {
    background: ${COLORS.primary};
  }

  .ant-picker-today-btn {
    color: ${COLORS.primary};
  }
`;

export const ExportIconButton = styled(Button)<{ $mobileOrder?: number }>`
  && {
    width: 40px;
    height: 40px;
    min-width: 40px;
    padding: 0;
    border: none;
    background: transparent;
    box-shadow: none;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;

    &:hover,
    &:focus {
      background: transparent !important;
      opacity: 0.85;
    }
  }

  && .ant-image {
    line-height: 0;
  }

  && .anticon-loading {
    font-size: 18px;
    color: ${COLORS.primary};
  }

  && .ant-image-img {
    width: 40px;
    height: 40px;
    display: block;
  }

  @media (max-width: 991px) {
    && {
      order: ${({ $mobileOrder }) => $mobileOrder ?? 0};
    }
  }
`;
